import { Component, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { getEmptyQuestion, Question } from 'src/app/interfaces/question';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { QuestionService } from 'src/app/services/question.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-wizard-question-list',
  templateUrl: './wizard-question-list.component.html',
  styleUrls: ['./wizard-question-list.component.scss'],
})
export class WizardQuestionListComponent implements OnInit {

  token: any;
  company: any;
  w_questionList: Question[] = [];
  currentQuestionId: any;
  loading: boolean = false
  constructor(
    private auth: AuthService,
    private compService: CompanyService,
    private questionService: QuestionService,
    private alertController: AlertController,
    private toastS: ToastService
  ) {
    this.questionService.QSave.subscribe(x => {
      this.foundIndex(x);
      // this.addNewQuestion()
    });
  }

  async ngOnInit() {
    this.token = await this.auth.getDecodedUserToken();
    this.company = await this.compService.getCompanyById(this.token.company).toPromise();

    console.log('this.TOKEN', this.token, 'this.COMPANY', this.company);
    this.loading = true;

    this.questionService.getAllQuestions(this.token.company, this.company.category).subscribe(q => {
      this.w_questionList = q;
      console.log("WizardQuestion: ", this.w_questionList);
      this.loading = false;
      // this.addNewQuestion();
    });

  }

  addNewQuestion() {
    let qempty = getEmptyQuestion();
    qempty.company = this.token.company;
    qempty.category = this.company.category
    this.foundIndex(qempty);
    this.questionService.QDataSubject.next(qempty);
  }

  async delete(question, index) {
    const alert = await this.alertController.create({
      header: 'LÖSCHEN',
      message: 'Möchtest du wirklich löschen?',
      buttons: [
        {
          text: 'Abbrechen',
          role: 'cancel'
        },
        {
          text: 'OK',
          role: 'ok',
          handler: () => {
            this.questionService.deleteQuestion(question._id).subscribe(x => {
              console.log("Löschen funktioniert", x);
              // TODO: Toastmessage einbauen
              // TODO: AlertController als Abfrage JA, NEIN einbauen
              // local löschen
              this.w_questionList.splice(index, 1);
              this.toastS.deleteToast();
            }, err => {
              console.log("Löschen funktioniert NICHT", err);
              this.toastS.deleteToastNot();
            })
          }
        }
      ]
    });
    alert.present();
  }

  foundIndex(question: any) {
    // bekommt entweder -1 wenn kein index gefunden wird oder index
    let emptyElementIndex = this.w_questionList.findIndex(index => index._id === undefined)
    if (emptyElementIndex > -1) {
      this.w_questionList.splice(emptyElementIndex, 1);
    }
    let index = this.w_questionList.findIndex(x => x._id === (question as Question)._id);
    this.currentQuestionId = question._id;
    if (index != -1) {
      this.w_questionList[index] = question;
    } else {
      this.w_questionList.unshift(question);
    }
  }

  edit(user) {
    console.log('AUSGEWÄHLTER USER:', user)
    this.foundIndex(user);
    this.questionService.QDataSubject.next(user);
  }
}
